import { Injectable } from '@angular/core';
import { LU_JobCodeServiceBase } from 'scaletech-jobs';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_JobCodeService extends LU_JobCodeServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
